import Vue from 'vue'
import VueRouter from 'vue-router'
import { getCookie } from '../utils/cookieNew'
import Error from '@/views/Error'
Vue.use(VueRouter)
const routes = [
  /* 에러페이지 */
  {
    path: '*',
    redirect: '/error',
    meta: { unauthorized: true }
  },
  {
    path: '/error',
    component: Error,
    meta: { unauthorized: true }
  },
  /* 오픈소스 라이선스 */
  {
    path: '/licenses_ios',
    name: 'licenses_ios',
    component: () => import('@/views/licenses_ios.vue'),
    meta: { unauthorized: true }
  },
  {
    path: '/licenses_android',
    name: 'licenses_android',
    component: () => import('@/views/licenses_android.vue'),
    meta: { unauthorized: true }
  },
  /* 본인인증 실패 페이지 */
  {
    path: '/identityFail',
    name: 'identityFail',
    component: () => import('@/views/IdentityFail.vue'),
    meta: { unauthorized: true }
  },
  /* 본인인증 성공 페이지 */
  {
    path: '/identitySuccess',
    name: 'identitySuccess',
    component: () => import('@/views/IdentitySuccess.vue'),
    meta: { unauthorized: true }
  },
  /* 비밀번호 변경 전 임시회원 여부 확인 페이지 */
  {
    path: '/isTemp',
    name: 'isTemp',
    component: () => import('@/views/member/IsTemp.vue'),
    meta: { unauthorized: true }
  },
  /* 메인 */
  {
    path: '/',
    name: 'main',
    component: () => import('@/views/MainPage.vue'),
    meta: { unauthorized: true }
  },
  {
    path: '/mainBanner',
    name: 'mainBanner',
    component: () => import('@/views/MainBanner.vue'),
    meta: { unauthorized: true }
  },
  /* 회원가입 */
  {
    path: '/joinTerms',
    name: 'joinTerms',
    component: () => import('@/views/join/JoinTerms.vue'),
    meta: { unauthorized: true }
  },
  {
    path: '/joinPrivacy',
    name: 'joinPrivacy',
    component: () => import('@/views/join/JoinPrivacy.vue'),
    meta: { unauthorized: true }
  },
  {
    path: '/temporaryPrivacy',
    name: 'temporaryPrivacy',
    component: () => import('@/views/join/TemporaryPrivacy.vue'),
    meta: { unauthorized: true }
  },
  {
    path: '/temporaryTerms',
    name: 'temporaryTerms',
    component: () => import('@/views/join/TemporaryTerms.vue'),
    meta: { unauthorized: true }
  },
  {
    path: '/choiceType',
    name: 'choiceType',
    component: () => import('@/views/join/ChoiceType.vue'),
    meta: { unauthorized: true }
  },
  {
    path: '/authorized',
    name: 'authorized',
    component: () => import('@/views/join/Authorized.vue'),
    meta: { unauthorized: true }
  },
  {
    path: '/authorizedTemporary',
    name: 'authorizedTemporary',
    component: () => import('@/views/join/AuthorizedTemporary.vue'),
    meta: { unauthorized: true }
  },
  {
    path: '/formData',
    name: 'formData',
    component: () => import('@/views/join/FormData.vue'),
    meta: { unauthorized: true }
  },
  {
    path: '/formDataTemporary',
    name: 'formDataTemporary',
    component: () => import('@/views/join/FormDataTemporary.vue'),
    meta: { unauthorized: true }
  },
  {
    path: '/joinDone',
    name: 'joinDone',
    component: () => import('@/views/join/Done.vue'),
    meta: { unauthorized: true }
  },
  {
    path: '/modifyDone',
    name: 'modifyDone',
    component: () => import('@/views/modify-user/ModifyDone.vue'),
    meta: { unauthorized: true }
  },
  {
    path: '/joinDoneTemporary',
    name: 'joinDoneTemporary',
    component: () => import('@/views/join/DoneTemporary.vue'),
    meta: { unauthorized: true }
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/LogIn.vue'),
    meta: { unauthorized: true }
  },
  {
    path: '/authorTrue',
    name: 'authorTrue',
    component: () => import('@/views/AuthorTrue.vue')
  },
  /* 회원정보 변경 -비밀번호체크 */
  {
    path: '/modifyUser/confirmPassword',
    name: 'confirmPassword',
    component: () => import('@/views/modify-user/ConfirmPassword.vue')
  },
  /* 회원정보 변경 -비밀번호체크 */
  {
    path: '/modifyUser/confirmPasswordInfo',
    name: 'confirmPasswordInfo',
    component: () => import('@/views/modify-user/ConfirmPasswordInfo.vue')
  },
  /* 회원정보 변경 -회원정보 변경 */
  {
    path: '/modifyUser/modify',
    name: 'modify',
    component: () => import('@/views/modify-user/Modify.vue')
  },
  /* 회원정보 변경 -회원 비밀번호 변경 */
  {
    path: '/modifyUser/passwordChange',
    name: 'passwordChange',
    component: () => import('@/views/modify-user/PasswordChange.vue')
  },
  /* 아이디 찾기 */
  {
    path: '/idFind',
    name: 'idFind',
    component: () => import('@/views/member/IdFind.vue'),
    props: true,
    meta: { unauthorized: true }
  },
  {
    path: '/idFindDone',
    name: 'idFindDone',
    component: () => import('@/views/member/IdFindDone.vue'),
    meta: { unauthorized: true }
  },
  /* 비밀번호 찾기 - 승인회원 */
  {
    path: '/passwordFindApproval',
    name: 'passwordFindApproval',
    component: () => import('@/views/member/PasswordFindApproval.vue'),
    meta: { unauthorized: true }
  },
  {
    path: '/passwordFindCertifyNext',
    name: 'passwordFindCertifyNext',
    component: () => import('@/views/member/PasswordFindCertifyNext.vue'),
    meta: { unauthorized: true }
  },
  {
    path: '/passwordFindApprovalDone',
    name: 'passwordFindApprovalDone',
    component: () => import('@/views/member/PasswordFindApprovalDone.vue'),
    meta: { unauthorized: true }
  },
  /* 비밀번호 찾기 - 인증회원 */
  {
    path: '/passwordFindCertify',
    name: 'passwordFindCertify',
    component: () => import('@/views/member/PasswordFindCertify.vue'),
    meta: { unauthorized: true }
  },
  {
    path: '/passwordFindCertifyDone',
    name: 'passwordFindCertifyDone',
    component: () => import('@/views/member/PasswordFindCertifyDone.vue'),
    meta: { unauthorized: true }
  },
  /* 회원탈퇴 */
  {
    path: '/modifyUser/confirmPasswordSecession',
    name: 'confirmPasswordSecession',
    component: () => import('@/views/modify-user/ConfirmPasswordSecession.vue')
  },
  {
    path: '/modifyUser/secession',
    name: 'secession',
    component: () => import('@/views/modify-user/Secession.vue'),
    meta: { unauthorized: true }
  },
  /* 비밀번호 변경완료 -  */
  {
    path: '/modifyUser/changeDone',
    name: 'changeDone',
    component: () => import('@/views/modify-user/PwChangeDone.vue'),
    meta: { unauthorized: true }
  },
  /* 설정창 */
  {
    path: '/controllSetting',
    name: 'controllSetting',
    component: () => import('@/views/util/ControlSetting.vue'),
    meta: { unauthorized: true }
  },
  /* 전화예약 */
  {
    path: '/telReservation_step1',
    name: 'telReservation_step1',
    component: () => import('@/views/reservation/guest/TelReservation_step1.vue'),
    meta: { unauthorized: true }
  },
  {
    path: '/telReservation_step2',
    name: 'telReservation_step2',
    component: () => import('@/views/reservation/guest/TelReservation_step2.vue'),
    meta: { unauthorized: true }
  },
  /* 내원사유 */
  {
    path: '/coming',
    name: 'coming',
    component: () => import('@/views/reservation/coming.vue'),
    meta: { unauthorized: true }
  },
  {
    path: '/passwordFind',
    name: 'passwordFind',
    component: () => import('@/views/PasswordFind.vue'),
    meta: { unauthorized: true }
  },
  /* 예약 */
  {
    path: '/reservation/explain',
    name: 'explain',
    component: () => import('@/views/reservation/member/Explain')
  },
  {
    path: '/reservation/choiceType',
    name: '/reservation/choiceType',
    component: () => import('@/views/reservation/member/ChoiceType')
  },
  {
    path: '/reservation/selectDisease',
    name: 'selectDisease',
    component: () => import('@/views/reservation/member/SelectDisease')
  },
  {
    path: '/reservation/selectDoctor',
    name: 'selectDoctor',
    component: () => import('@/views/reservation/member/SelectDoctor')
  },
  {
    path: '/reservation/selectDate',
    name: 'selectDate',
    component: () => import('@/views/reservation/member/SelectDate')
  },
  {
    path: '/reservation/reCare',
    name: 'reCare',
    component: () => import('@/views/reservation/member/ReCare.vue')
  },
  {
    path: '/reservation/rebooking',
    name: 'rebooking',
    component: () => import('@/views/reservation/member/Rebooking.vue')
  },
  {
    path: '/reservation/updateDate',
    name: 'updateDate',
    component: () => import('@/views/reservation/member/UpdateDate')
  },
  {
    path: '/reservation/researchDate',
    name: 'researchDate',
    component: () => import('@/views/reservation/member/ResearchDate')
  },
  {
    path: '/reservation/reservationConfirm',
    name: 'reservationConfirm',
    component: () => import('@/views/reservation/member/ReservationConfirm')
  },
  {
    path: '/reservation/reservationConfirmDate',
    name: 'reservationConfirmDate',
    component: () => import('@/views/reservation/member/ReservationConfirmDate')
  },
  {
    path: '/reservation/selectDateExample',
    name: 'selectDateExample',
    component: () => import('@/views/reservation/member/SelectDateExample')
  },
  /* 의료진 소개 */
  {
    path: '/doctor/list',
    name: 'doctorList',
    component: () => import('@/views/doctor/DoctorList'),
    meta: { unauthorized: true }
  },
  {
    path: '/doctor/schedule',
    name: 'schedule',
    component: () => import('@/views/doctor/Schedule'),
    meta: { unauthorized: true }
  },
  /* 검사결과 조회 */
  {
    path: '/checkup/checkupList',
    name: 'checkupList',
    component: () => import('@/views/checkup/CheckupList')
  },
  {
    path: '/checkup/checkupDetail/:checkupCode',
    name: 'checkupDetail',
    component: () => import('@/views/checkup/CheckupDetail')
  },
  {
    path: '/checkup/checkupDate',
    name: 'checkupDate',
    component: () => import('@/views/checkup/CheckupDate')
  },
  {
    path: '/checkup/blood/bloodCheckup/:checkupCode',
    name: 'bloodCheckup',
    component: () => import('@/views/checkup/blood/BloodCheckup')
  },
  {
    path: '/checkup/pathology/pathologyCheckup/:checkupCdoe',
    name: 'pathologyCheckup',
    component: () => import('@/views/checkup/pathology/PathologyCheckup')
  },
  /* 푸쉬 */
  {
    path: '/pushList',
    name: '/pushList',
    component: () => import('@/views/pushList/PushList')
  },
  /* 제증명 발급 신청 */
  {
    path: '/certificateList',
    name: 'certificateList',
    component: () => import('@/views/certificate/CertificateList')
  },
  {
    path: '/certificateRequest',
    name: 'certificateRequest',
    component: () => import('@/views/certificate/CertificateRequest')
  },
  {
    path: '/certificateRequestDone',
    name: 'certificateRequestDone',
    component: () => import('@/views/certificate/CertificateRequestDone')
  },
  {
    path: '/certificateReference',
    name: 'certificateReference',
    component: () => import('@/views/certificate/CertificateReference')
  },
  /* 신청내역 */
  {
    path: '/certificateLookupList',
    name: 'certificateLookupList',
    component: () => import('@/views/certificate/CertificateLookupList')
  },
  {
    path: '/certificateLookupDate',
    name: 'certificateLookupDate',
    component: () => import('@/views/certificate/CertificateLookupDate')
  },
  {
    path: '/certificateLookupDetail/:certificateIssuanceId',
    name: 'certificateLookupDetail',
    component: () => import('@/views/certificate/CertificateLookupDetail')
  },
  /* 수술 */
  {
    path: '/surgery/surgeryReservationList',
    name: 'surgeryReservationList',
    component: () => import('@/views/surgery/reservation/SurgeryReservationList')
  },
  {
    path: '/surgery/SurgeryReservationListAttachment',
    name: 'SurgeryReservationListAttachment',
    component: () => import('@/views/surgery/reservation/SurgeryReservationListAttachment')
  },
  {
    path: '/surgery/surgeryReservationDate',
    name: 'surgeryReservationDate',
    component: () => import('@/views/surgery/reservation/SurgeryReservationDate')
  },
  {
    path: '/surgery/beforeCaution',
    name: 'beforeCaution',
    component: () => import('@/views/surgery/BeforeCaution'),
    meta: { unauthorized: true }
  },
  {
    path: '/surgery/afterCaution',
    name: 'afterCaution',
    component: () => import('@/views/surgery/AfterCaution')
  },
  {
    path: '/surgery/afterCare',
    name: 'afterCare',
    component: () => import('@/views/surgery/AfterCare')
  },
  {
    path: '/surgery/surgeryReviewList',
    name: 'surgeryReviewList',
    component: () => import('@/views/surgery/SurgeryReviewList')
  },
  {
    path: '/surgery/surgeryReview/:code',
    name: 'surgeryReview',
    component: () => import('@/views/surgery/SurgeryReview')
  },
  {
    path: '/surgery/surgeryConsent',
    name: 'surgeryConsent',
    component: () => import('@/views/surgery/SurgeryConsent'),
    meta: { unauthorized: true }
  },
  {
    path: '/surgery/surgeryConsentList',
    name: 'surgeryConsentList',
    component: () => import('@/views/surgery/SurgeryConsentList'),
    meta: { unauthorized: true }
  },
  {
    path: '/surgery/voiceCare',
    name: 'voiceCare',
    component: () => import('@/views/surgery/VoiceCare')
  },
  {
    path: '/surgery/kakaoUrl',
    name: 'kakaoUrl',
    component: () => import('@/views/surgery/KakaoUrl')
  },
  /* 흉터관리 */
  {
    path: '/scar/scarCheck',
    name: 'scarCheck',
    component: () => import('@/views/scar/ScarCheck')
  },
  {
    path: '/scar/scarUpload/:code',
    name: 'scarUpload',
    component: () => import('@/views/scar/ScarUpload')
  },
  {
    path: '/scar/uploadTest',
    name: 'uploadTest',
    component: () => import('@/views/scar/UploadTest')
  },
  {
    path: '/scar/scarDetail/:code',
    name: 'scarDetail',
    component: () => import('@/views/scar/ScarDetail')
  },
  {
    path: '/scar/scarDetailPrac',
    name: 'scarDetailPrac',
    component: () => import('@/views/scar/ScarDetail_practice')
  },
  {
    path: '/scar/scarAdd',
    name: 'scarAdd',
    component: () => import('@/views/scar/ScarAdd')
  },
  {
    path: '/scar/scarList',
    name: 'scarList',
    component: () => import('@/views/scar/ScarList')
  },
  {
    path: '/scar/scarPlugIn',
    name: 'scarPlugIn',
    component: () => import('@/views/scar/ScarPlugIn')
  },
  {
    path: '/scar/scarDetail_practice',
    name: 'scarDetail_practice',
    component: () => import('@/views/scar/ScarDetail_practice')
  },
  /* 병원안내 */
  {
    path: '/info/telInfo',
    name: 'telInfo',
    component: () => import('@/views/info/TelInfo'),
    meta: { unauthorized: true }
  },
  {
    path: '/info/scheduleInfo',
    name: 'scheduleInfo',
    component: () => import('@/views/info/ScheduleInfo'),
    meta: { unauthorized: true }
  },
  {
    path: '/info/facilityInfo',
    name: 'facilityInfo',
    component: () => import('@/views/info/FacilityInfo'),
    meta: { unauthorized: true }
  },
  {
    path: '/info/hospitalInfo',
    name: 'hospitalInfo',
    component: () => import('@/views/info/HospitalInfo'),
    meta: { unauthorized: true }
  },
  {
    path: '/info/wayInfo',
    name: 'wayInfo',
    component: () => import('@/views/info/WayInfo'),
    meta: { unauthorized: true }
  },
  {
    path: '/info/faq',
    name: 'faq',
    component: () => import('@/views/info/Faq'),
    meta: { unauthorized: true }
  },
  {
    path: '/chatbot',
    name: 'chatbot',
    component: () => import('@/views/info/Chatbot'),
    meta: { unauthorized: true }
  },
  /* 공지사항 */
  {
    path: '/noticeList',
    name: 'noticeList',
    title: 'ThanQ | 공지사항',
    component: () => import('@/views/board/NoticeList'),
    meta: { unauthorized: true }
  },
  {
    path: '/notice/:code',
    name: 'noticeDetail',
    component: () => import('@/views/board/NoticeDetail'),
    meta: { unauthorized: true }
  },
  {
    path: '/noticeWrite',
    name: 'noticeWrite',
    component: () => import('@/views/board/NoticeWrite')
  },
  /* 개인정보처리방침 */
  {
    path: '/privacy',
    name: 'privacy',
    component: () => import('@/views/util/Privacy'),
    meta: { unauthorized: true }
  },
  /* 이용약관 */
  {
    path: '/terms',
    name: 'terms',
    component: () => import('@/views/util/Terms'),
    meta: { unauthorized: true }
  },
  /* 환자의 권리와 의무 */
  {
    path: '/patient',
    name: 'patient',
    component: () => import('@/views/util/Patient'),
    meta: { unauthorized: true }
  }
]
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})
router.beforeEach(async (to, from, next) => {
  if (/thanqApp/.test(navigator.userAgent)) {
    if (to.matched.some(record => record.meta.unauthorized) || (getCookie('token') !== undefined)) {
      sessionStorage.setItem('pathToLoadUnAuth', to.path)
      sessionStorage.setItem('pathFromLoadUnAuth', from.path)
      console.log('권한 필요없는 경로', to.path)
      return next()
    } else {
      sessionStorage.setItem('pathToLoadAuth', to.path)
      sessionStorage.setItem('pathFromLoadAuth', from.path)
      console.log('권한 필요한 경로', to.path)
      return next('/login')
    }
  } else {
    if (to.matched.some(record => record.meta.unauthorized) || (getCookie('token') !== undefined)) {
      sessionStorage.setItem('pathToLoadUnAuth', to.path)
      sessionStorage.setItem('pathFromLoadUnAuth', from.path)
      console.log('권한 필요없는 경로', to.path)
      return next()
    } else {
      sessionStorage.setItem('pathToLoadAuth', to.path)
      sessionStorage.setItem('pathFromLoadAuth', from.path)
      console.log('권한 필요한 경로', to.path)
      return next('/login')
    }
  }
})
export default router
